export const getGroupPresentationImageWrapperSizes = ($size) => {
    if ($size === 'small') {
        return {
            maxWidth: { _: '130px', m: '100px' },
            minWidth: { _: '130px', m: '100px' },
            mr: 3,
        };
    }
    return {
        maxWidth: { _: '221px', m: '185px' },
        minWidth: { _: '221px', m: '185px' },
        mr: 5,
    };
};
export const getEventPresentationImageWrapperSizes = ($size) => {
    if ($size === 'small') {
        return {
            width: '145px',
            maxHeight: '78px',
        };
    }
    return {
        width: '186px',
        maxHeight: '105px',
    };
};
//# sourceMappingURL=utils.js.map